/**
 * Utility functions for managing charts collapse state in cookies
 */

const CHARTS_COLLAPSE_COOKIE_NAME = 'job-charts-collapsed';
const ONE_YEAR_IN_SECONDS = 60 * 60 * 24 * 365;

/**
 * Read charts collapse state from cookie (client-side only)
 * Returns true if collapsed, false if expanded, null if not set
 */
export function readChartsCollapseCookie(): boolean | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp(`(?:^|; )${CHARTS_COLLAPSE_COOKIE_NAME}=([^;]+)`));
  if (!match) return null;
  const value = decodeURIComponent(match[1]);
  return value === 'true';
}

/**
 * Write charts collapse state to cookie
 */
export function writeChartsCollapseCookie(collapsed: boolean): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${CHARTS_COLLAPSE_COOKIE_NAME}=${encodeURIComponent(collapsed ? 'true' : 'false')}; Path=/; Max-Age=${ONE_YEAR_IN_SECONDS}; SameSite=Lax`;
}



